import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslate } from "react-polyglot";
import { Box, Typography } from "@material-ui/core";
import { useAuth } from "./AuthProvider.jsx";
import useCompanyPublicId from "../../hooks/useCompanyPublicId.js";
import useEffectAsync from "../../hooks/useEffectAsync.js";
import { useBaseData } from "../Data/BaseDataProvider.jsx";
import useExtractRouteParamInt from "../../hooks/useExtractRouteParamInt.js";
import MyBackdrop from "../../SharedComponents/MyBackdrop.jsx";

/** */
const LoginKeyHandler = () => {
  const { domain, companyName } = useCompanyPublicId();
  const { getAvailableSubjects, getAvailableSubjectsForCompany, chooseSubject } = useBaseData();

  const { user, loginByKey } = useAuth();
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const loginKey = params.get("loginKey");
  const t = useTranslate();

  const deckIdDomain = useExtractRouteParamInt("/learn/:deckId/login", "deckId");
  const deckIdCompany = useExtractRouteParamInt("/:companyName/learn/:deckId/login", "deckId");
  const deckId = deckIdDomain || deckIdCompany;

  const eventIdDomain = useExtractRouteParamInt("/events/:eventId/login", "eventId");
  const eventIdCompany = useExtractRouteParamInt("/:companyName/events/:eventId/login", "eventId");
  const eventId = eventIdDomain || eventIdCompany;

  // загружаем данные о компании по домену или urn
  useEffect(() => {
    getAvailableSubjectsForCompany(domain || companyName).then();
  }, []);

  // по извлеченному из url loginKey происходит авторизация юзера.
  // deckId, eventId необходимы чтоб установить для юзера текуший предмет
  useEffectAsync(async () => {
    if (!user) {
      if (loginKey) {
        if (domain || companyName) {
          const resp = await loginByKey(loginKey, deckId, eventId);
          if (!resp) {
            history.replace("/auth");
          }
        }
      } else {
        history.replace("/");
      }
    }
  }, [loginKey, domain, companyName]);

  // после авторизации если в url есть deckId или eventId, то осуществляется вход в предмет и перенаправление в
  // соответствующий раздел приложения
  useEffectAsync(async () => {
    if (loginKey && user) {
      getAvailableSubjects().then();
      if (deckId || eventId) {
        if (await chooseSubject(user.subjectId)) {
          deckId && history.replace(`/learn/${deckId}`);
          eventId && history.replace(`/events/${eventId}`);
        }
      } else {
        history.replace("/subjects");
      }
    }
  }, [user]);

  return (
    <Box padding="80px">
      <Typography variant="h5" align="center">
        {t("loginInProcess")}
      </Typography>
      <MyBackdrop open={true} />
    </Box>
  );
};

export default LoginKeyHandler;
